<template>
    <!--添加/编辑档案目录节点弹窗-->
    <td-dialog width="625px" :title="title" :before-close="dialogClose" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :inline="true" :rules="rules" :model="form" labelWidth="80px">
            <el-row>
                <el-form-item :label="$t('workFlowProcessAudit.NODE_NAME')" prop="sName">
                    <td-input maxlength="50" v-model="form.sName"></td-input>
                </el-form-item>
                <el-form-item :label="$t('workFlowProcessAudit.NODE_TYPE')" prop="iType">
                    <td-select :disabled="operateFlag === 'edit'" v-model="form.iType" :options="nodeTypeOptions" keys="key" text="name"></td-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item :label="$t('pgCommon.DESCRIPTION')" prop="sRemark">
                    <td-input style="width: 490px" v-model="form.sRemark" type="textarea" rows="5" maxlength="500"></td-input>
                </el-form-item>
            </el-row>
            <el-row v-if="form.iType && isPermitEdit">
                <el-form-item class="fileCheckInfo" :label="$t('workFlowProcessAudit.AUDIT_INFO')" prop="selectedCheck">
                    <td-checkbox-group :key="form.selectedCheck" :allList="allCheck" v-model="form.selectedCheck" keys="sId" text="sRemark"></td-checkbox-group>
                </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer">
            <td-button type="primary" :loading="submitLoading" @click="save">{{ this.$t('pgCommon.SAVE') }}</td-button>
            <td-button @click="dialogClose">{{ this.$t('pgCommon.CANCEL') }}</td-button>
        </div>
    </td-dialog>
</template>

<script>
import Api from '../../assets/api';
export default {
    name: 'addOrUpdateTreeNode',
    props: ['dialogVisible', 'title', 'data', 'operateFlag'],
    data() {
        return {
            submitLoading: false,
            isPermitEdit: true, //是否可编辑labelGroup,若档案已经关联用户，则不可重新勾选编辑扩展变量信息。
            form: {
                sName: '', //节点名称
                sParentId: '', //父节点id
                iType: '', //节点类型
                auditGroupRelateVoList: '', //节点关联档案信息
                sRemark: '', //描述
                selectedCheck: [1, 2] //复选框被选中集合
            },
            nodeTypeOptions: [{ key: 0, name: this.$t('workFlowProcessAudit.FOLDER') }, { key: 1, name: this.$t('workFlowProcessAudit.AUDIT_FILE') }], //节点类型下拉框选项
            allCheck: [{ sId: 1, sRemark: this.$t('pgCommon.USERNAME') }, { sId: 2, sRemark: 'workFlowProcessAudit.ORG_STRUCT' }], //复选框所有勾选框
            rules: {
                sName: [{ required: true, message: this.$t('workFlowProcessAudit.INPUT_NODE_NAME'), trigger: 'blur' }],
                iType: [{ required: true, message: this.$t('workFlowProcessAudit.INPUT_NODE_TYPE'), trigger: 'blur' }],
                selectedCheck: [{ required: true, message: this.$t('workFlowProcessAudit.SELECT_AUDIT_INFO'), trigger: 'blur' }]
            }
        };
    },
    created() {
        //初始化表单复选框
        this.initCheckBox();
        //初始化form表单信息（编辑情况下）
        this.initTreeNodeInfo();
        //判断是否可编辑扩展变量信息
        this.isPermitEditLabelGroup();
    },
    methods: {
        //是否可编辑扩展变量信息
        isPermitEditLabelGroup() {
            let params = this.data.id;
            Api.queryAuditRelateUserInfo(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/auditManage/queryAuditRelateUserInfo', response);
                    return;
                }
                if (response.data.statusCode === 'API-COMMON-INF-OK'){
                    if (this.operateFlag === 'edit' && (response.data.content.length !== 0 || !this.$util.isEmpty(response.data.content))) {
                        this.isPermitEdit = false;
                    }
                }
            });
        },
        //初始化表单复选框
        initCheckBox() {
            this.allCheck = [{ sId: 1, sRemark: this.$t('pgCommon.USERNAME') }, { sId: 2, sRemark: this.$t('assignAuditPermission.ORG') }];
            let params = { needLabelInfo: true };
            Api.searchLabelGroupByIds(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/workFlowLabelGroup/queryLabelGroup', response);
                    return;
                }
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    response.data.content.forEach(item => {
                        if (!this.$util.isEmpty(item.labelList)) {
                            this.allCheck.push(item);
                        }
                    });
                }
            });
            if (this.operateFlag === 'edit') {
                let selectedList = {};
                try {
                    selectedList = JSON.parse(JSON.stringify(this.data.sLabelGroupIds));
                } catch (e) {
                    console.log('Json conversion failed', e);
                }
                this.form.selectedCheck = selectedList.split(',');
                this.form.selectedCheck.push(1);
                this.form.selectedCheck.push(2);
            }
        },
        //初始化form表单信息
        initTreeNodeInfo() {
            //添加操作则只赋值父亲id
            if (this.operateFlag === 'add') {
                this.form.sParentId = this.data.id;
            }
            //编辑操作将父组件传过来的信息赋值给form表单
            if (this.operateFlag === 'edit') {
                this.form = Object.assign({}, this.data);
                this.form.sId = this.data.id;
                console.dir(this.data);
            }
        },
        //添加节点
        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    let params = {};
                    try {
                        params = JSON.parse(JSON.stringify(this.form));
                    } catch (e) {
                        console.log('Json conversion failed', e);
                    }
                    if (this.operateFlag === 'add') {
                        let auditRelateVoList = [];
                        this.form.selectedCheck.splice(0, 2);
                        let selectedCheck = this.form.selectedCheck;
                        selectedCheck.forEach(item => {
                            this.allCheck.forEach(element => {
                                if (item === element.sId) {
                                    let obj = {
                                        sLabelGroupId: item,
                                        iOrder: element.iOrder
                                    };
                                    try {
                                        auditRelateVoList.push(JSON.parse(JSON.stringify(obj)));
                                    } catch (e) {
                                        console.log('Json conversion failed', e);
                                    }
                                }
                            });
                        });
                        params.auditGroupRelateVoList = auditRelateVoList;
                        Api.addAuditNode(params, response => {
                            this.submitLoading = false;
                            if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                                this.$log.error('/auditGroupManage/addAuditNode', response);
                                return;
                            }
                            if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                                this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.ADD_NODE_FAIL') });
                            } else {
                                this.$message({ type: 'success', showClose: true, message: this.$t('workFlowProcessAudit.ADD_NODE_SUCCESS') });
                                this.$emit('queryFileListTree');
                                this.$emit('queryFileListTable');
                                this.dialogClose();
                            }
                        });
                    }
                    if (this.operateFlag === 'edit') {
                        Api.updateAuditNode(params, response => {
                            this.submitLoading = false;
                            if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                                this.$log.error('/auditGroupManage/updateAuditNode', response);
                                return;
                            }
                            if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                                this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.UPDATE_NODE_FAIL') });
                            } else {
                                this.$message({ type: 'success', showClose: true, message: this.$t('workFlowProcessAudit.UPDATE_NODE_SUCCESS') });
                                this.$emit('queryFileListTree');
                                this.$emit('queryFileListTable');
                                this.dialogClose();
                            }
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //关闭弹窗
        dialogClose() {
            this.$emit('dialogClose');
        }
    }
};
</script>

<style scoped>
.fileCheckInfo >>> .el-form-item__content {
    width: 490px;
}
.fileCheckInfo >>> .el-checkbox {
    width: 95px;
}
</style>
